import { InvoiceExtractionSettings } from "./types";

export const transformInvoiceExtractionSettings = (res: any): InvoiceExtractionSettings => ({
  pipeline: res.pipeline ?? "direct",
  model: res.model ?? "",
  ocrModel: res.ocrModel ?? "",
  prompt: res.prompt ?? "",
  defaultModel: res.defaultModel ?? "",
  defaultOcrModel: res.defaultOcrModel ?? "",
  defaultPrompt: res.defaultPrompt ?? "",
  isConfigured: res.isConfigured ?? false,
  isOcrAvailable: res.isOcrAvailable ?? false,
  googleProjectId: res.googleProjectId ?? "",
  googleProcessorId: res.googleProcessorId ?? "",
  googleLocation: res.googleLocation ?? "",
  hasGoogleCredentials: res.hasGoogleCredentials ?? false,
  googleServiceAccount: res.googleServiceAccount ?? "",
  canStoreCredentials: res.canStoreCredentials ?? false,
});
